import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { TemplateResult } from 'lit-html';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { FontSizes, FontWeights } from '../../../../../../../types/common/types';
import { CSSResultGroup } from '@lit/reactive-element/css-tag';
import { styles } from '../view/styles';
import { ButtonColors, ButtonTypes } from '../../../../../../../ui/gzButton/types';
import { ToastPositionX, ToastPositionY, ToastSeverity } from '../../../../../../../ui/gzToastNotification/type';
import { GzToastNotificationWebComponent } from '../../../../../../../ui/gzToastNotification';

export abstract class GzAutomaticActionSettingsWebComponent<T> extends LitElement {
  @property({ type: Object, attribute: false, reflect: false })
  public settings: T;

  public closeSideMenuCallback: () => void;

  public static get styles(): CSSResultGroup {
    return styles;
  }

  protected render(): TemplateResult {
    return html`
      <div class="wrapper">
        <div class="header mt-6 mb-1">
          <gz-title class="mb-2" fontweight="${FontWeights.MEDIUM}" fontsize="${FontSizes.HEADING_5}">
            ${this.getTitle()}
          </gz-title>
        </div>

        <div class="content pr-1">
          <gz-text class="mt-1" fontsize="${FontSizes.PARAGRAPH_13}"> ${this.getDescription()} </gz-text>

          ${this.renderContent()}
        </div>

        <div class="footer">
          <gz-button @click="${this.onEditActionClick}">${translateFn('Save#preserve state')}</gz-button>
          <gz-button
            class="pl-2"
            type="${ButtonTypes.OUTLINE}"
            color="${ButtonColors.SECONDARY}"
            @click="${this.closeSideMenuCallback}"
          >
            ${translateFn('Cancel')}
          </gz-button>
        </div>
      </div>
    `;
  }

  protected abstract getTitle(): string;

  protected abstract getDescription(): string;

  protected abstract renderContent(): TemplateResult;

  protected abstract editAction(): void;

  private onEditActionClick(): void {
    this.closeSideMenuCallback();

    this.editAction();

    GzToastNotificationWebComponent.buildToastWrapperElement({
      message: translateFn('Successfully changed action settings.'),
      severity: ToastSeverity.SUCCESS,
      x: ToastPositionX.RIGHT,
      y: ToastPositionY.BOTTOM,
      autoCloseDelayMs: 5000,
    });
  }
}
